import React from 'react';
import {
    Create, SimpleForm, TextInput
} from 'react-admin';
import Grid from '@material-ui/core/Grid';


const BuyCamacolCreate = (props) => {

    return (
        <Create title='Compra camacol' {...props}>
            <SimpleForm /* validate={validateBuyCamacolFields} */>
                <Grid container spacing={16}>
                    <Grid item xs={6}>
                        <TextInput source="name" label="Nombre" fullWidth={true} />
                    </Grid>
                </Grid>
            </SimpleForm>
        </Create>
    )
}

export default BuyCamacolCreate;